import { Backdrop, Box, Button, CircularProgress, Typography } from '@mui/material'
import React, { useState } from 'react'
import Slider from 'react-slick'

import pictureA from '../../images/promo/1.png'
import pictureB from '../../images/promo/2.png'
import pictureC from '../../images/promo/3.png'

import vcplogo from '../../images/VCPLogo.png'
import { useNavigate } from 'react-router-dom'

export const AppTour = ({userId}) => {

  const navigate = useNavigate()

  const sliderSettings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false
  };

  const FeatureBox = ({text, img}) => {
    return (
        <Box sx={{
            width: "80%",
            height: "80vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "30px"            
        }}>
            <img src={img} alt="" style={{
                width: "100%",
                height: "100%",
                borderRadius: "10px"
            }} />
            <Typography variant="subtitle1" textAlign={"center"}>
                {text}
            </Typography>
        </Box>
    )
  } 

  const features = [
    {
        img: pictureA,
        text: "Manage your screens wherever you are. Select content, adjust settings, and maintain full control over your signage devices"
    },
    {
        img: pictureB,
        text: "Create various widgets such as weather, a YouTube player, or uploaded photos and videos. Unleash your creativity and place them in your playlists"
    },
    {
        img: pictureC,
        text: "You don't have to control time anymore! VCPlayer will do it for you. Use the scheduler to plan when each playlist appears on screen"
    }
  ]

  return (
    <Box sx={{
        background: "url(/images/loginside.png) ,rgba(255,255,255,.1)",
        backgroundPosition: "center", backgroundSize: "cover",
        width: "100%",
        height: "100vh"
    }}>
        <Slider {...sliderSettings}>
            {features.map(f => {
                return (
                    <FeatureBox text={f.text} img={f.img} />
                )
            })}
            <Box sx={{
                width: "80%",
                height: "80vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "30px"            
            }}>
                <img src={vcplogo} style={{width: '160px'}} />
                <Typography variant='h3' color={"primary.main"}>Are You In?</Typography>
                <Button variant="contained" onClick={() => window.location.replace(`/user-details/${userId}#mysubscriptionsfl`)}>Go to VCPlayer</Button>
            </Box>
        </Slider>
    </Box>
  )
}


